import { render, staticRenderFns } from "./GameStage.vue?vue&type=template&id=39355a5e&scoped=true&"
import script from "./GameStage.vue?vue&type=script&lang=ts&"
export * from "./GameStage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39355a5e",
  null
  
)

export default component.exports